import React from 'react';
import { connect } from 'react-redux'
import { usuarioSelector, sucursalSelector, resultadoAutenticacionSelector } from '../../selectors/sessionSelector'
import SeleccionSucursal from '../../components/SeleccionSucursal'
import * as sessionActions from '../../reducers/sessionReducer/actions'
import { bindActionCreators } from 'redux'

const SeleccionSucursalContainer = ({usuario, setSucursal, sucursal, sagaFetchUsuarioLogeado, resultadoAutenticacion}) => {

  React.useEffect(() => {
    sagaFetchUsuarioLogeado();
  }, [])

  React.useEffect(() => {
    setSucursalUsuario();
  }, [usuario])

  const setSucursalUsuario = () => {
    if(!sucursal?.idSucursal){
      if(usuario && usuario.sucursales.length === 1 && resultadoAutenticacion.autenticado){
        localStorage.setItem('sucursalSeleccionada', usuario.sucursales[0].idSucursal);
        setSucursal(usuario.sucursales[0]);
          if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
            window.location.hash = '/Pedidos'
            return
          }
            
          if(usuario && usuario.idRol === 2){
              window.location.hash = '/Articulo'
              return
          }
      }
    }

  }
 

  const handleSucursal = (item) => {
    if(item){
      localStorage.setItem('sucursalSeleccionada', item.idSucursal);
      setSucursal(item);
      if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
        window.location.hash = '/Pedidos'
        return
      }
      if(usuario && usuario.idRol === 2){
          window.location.hash = '/Articulo'
          return
      }
    }
      
  }

  return (
    <div>
      {usuario.sucursales.length > 1 && <SeleccionSucursal usuario={usuario} handleSucursal={handleSucursal} />}
    </div>
  );
  
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
        ...sessionActions,
	}, dispatch)
}

const mapStateToProps = (state) => ({
  usuario: usuarioSelector(state),
  sucursal: sucursalSelector(state),
  resultadoAutenticacion: resultadoAutenticacionSelector(state)  
})

export default connect(mapStateToProps, mapDispatchToProps)(SeleccionSucursalContainer)
